import request from '../index';
/** 和项目管理有关的接口 **/

/** 
* DataLib
* @params {string} data.dataLibType 资料库类型
* @params {string} data.fileLink 文件下载链接
* @params {string} data.fileName 文件名称
* @params {string} data.fileType 文件类型
* @params {number} data.id 
* @params {boolean} data.latestVersion 是否最新版本
* @params {string} data.projectLifeCycle 项目生命周期阶段
* @params {string} data.structureName 组织架构名称
* @params {string} data.uploadTime 上传时间
* @params {number} data.userId 
* @params {string} data.username 
* @params {string} data.version 版本
* @params {string} data.wbs 
* @params {string} data.workRecords 工作记录
*/

/** 
* ProjectLifeCycle
* @params {number} data.id 
* @params {string} data.project 项目
* @params {string} data.projectLifeCycle 项目生命周期阶段
* @params {string} data.projectStatus 项目状态：未开始/进行时/结束
* @params {number} data.userId 
* @params {string} data.username 项目负责人
*/

/** 
* 删除资料库
* @params {array} ids
*/
export const deleteDataLib = (data) => request.delete('api-qc/deleteDataLib', { data });

/** 
* 删除
* @params {array} ids
*/
export const deleteProjectLifeCycle = (data) => request.delete('api-qc/deleteProjectLifeCycle', { data });

/** 
* 获得项目生命周期
* @params {string} params.project 项目
*/
export const getProjectLifeCycle = (params) => request.get('api-qc/getProjectLifeCycle', { params });

/** 
* 获得研发部资料库
* @params {string} params.dataLibType 资料库类型
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.projectLifeCycle 项目生命周期阶段
* @params {string} params.structureName 组织架构名称
*/
export const getRNDDataLibList = (params) => request.get('api-qc/getRNDDataLibList', { params });

/** 
* 添加研发部资料库
* @params {DataLib} dataLib
*/
export const insertRNDDataLib = (data) => request.post('api-qc/insertRNDDataLib', data);

/** 
* 添加or更新项目生命周期
* @params {ProjectLifeCycle} structure
*/
export const saveProjectLifeCycle = (data) => request.post('api-qc/saveProjectLifeCycle', data);

/** 
* 修改资料库信息
* @params {DataLib} dataLib
*/
export const updateDataLib = (data) => request.put('api-qc/updateDataLib', data);

/** 
* 上传研发资料库
*/
export const uploadRNDDataLib = (data) => request.post('api-qc/uploadRNDDataLib', data);

/**
 * 获得一条研发部资料库
*/
export const getOneRNDDataLib = (params) => request.get('/api-qc/getOneRNDDataLib', { params });

/**
 * 获得问题需求进度表列表
*/
export const getProblemRequirementScheduleList = (params) => request.get('/api-qc/getProblemRequirementScheduleList', { params });

/**
 * 添加问题需求进度表
*/
export const insertProblemRequirementSchedule = (data) => request.post('/api-qc/insertProblemRequirementSchedule', data)

/**
 * 修改问题需求进度表
*/
export const updateProblemRequirementSchedule = (data) => request.put("/api-qc/updateProblemRequirementSchedule", data)

/**
 * 删除问题需求进度表
*/
export const deleteProblemRequirementSchedule = (data) => request.delete('/api-qc/deleteProblemRequirementSchedule', { data });

/**
 * 删除文件
*/
export const deleteFile = (data) => request.delete('/api-qc/deleteFile', { data });

/**
 * 添加or修改项目计划表
*/
export const saveProjectSchedule = (data) => request.post('/api-qc/saveProjectSchedule', data);

/**
 * 添加项目计划表
*/
export const insertProjectSchedule = (data) => request.post('/api-qc/insertProjectSchedule', data);

/**
* 获得项目计划列表
*/
export const getProjectScheduleList = (params) => request.get('/api-qc/getProjectScheduleList', { params });

/**
 * 更新项目计划表
*/
export const updateProjectSchedule = (data) => request.put(`/api-qc/updateProjectSchedule`, data);

/**
 * 获得一条项目计划表
*/
export const getOneProjectSchedule = (params) => request.get('/api-qc/getOneProjectSchedule', { params });

/**
 * 删除项目计划表
*/
export const deleteProjectSchedule = (data) => request.delete('/api-qc/deleteProjectSchedule', { data });

/**
 * 获得设计变更列表
*/
export const getDesignChangesList = (params) => request.get('/api-qc/getDesignChangesList', { params });

/**
 * 添加or修改审批节点
*/
export const saveApprovalNode = (data) => request.post('/api-qc/saveApprovalNode', data);

/**
 * 修改设计变更
*/
export const insertDesignChanges = (data) => request.post('/api-qc/insertDesignChanges', data);

/**
 * 修改设计变更
*/
export const updateDesignChanges = (data) => request.put('/api-qc/updateDesignChanges', data);

/**
 * 删除设计变更
*/
export const deleteDesignChanges = (data) => request.delete('/api-qc/deleteDesignChanges', { data });

/**
 * 删除审批节点
*/
export const deleteApprovalNode = (data) => request.delete('/api-qc/deleteApprovalNode', { data });

/**
 * 获取物料型号编码列表
*/
export const getMaterialModelCodeList = (params) => request.get('/api-qc/getMaterialModelCodeList', { params });

/**
 * 生成物料型号编码
*/
export const insertMaterialModelCode = (data) => request.post('/api-qc/insertMaterialModelCode', data);

/**
 * 修改物料型号编码
*/
export const updateMaterialModelCode = (data) => request.put('/api-qc/updateMaterialModelCode', data);

/**
 * 上传项目图片
*/
export const uploadProjectImage = (data) => request.post('/api-qc/uploadProjectImage', data);

/**
 * 获得BOM表
*/
export const getBOMDataList = (params) => request.get('/api-qc/getBOMDataList', { params });

/**
 * 添加BOM表
*/
export const insertBOMData = (data) => request.post('/api-qc/insertBOMData', data);

/**
 * 更新BOM表
*/
export const updateBOMDataList = (data) => request.post('/api-qc/updateBOMDataList', data);

/**
 * 获取物料型号编码列表(无分页)
*/
export const getAllMaterialModelCode = (params) => request.get('api-qc/getAllMaterialModelCode', { params });

/**
 * 删除BOM表记录
*/
export const deleteBOMData = (data) => request.delete('/api-qc/deleteBOMData', { data });

/**
 * 导出BOM表
*/
export const exportBOMData = (params) => request.get('/api-qc/exportBOMData', { params, responseType: 'blob' });

/**
 * 添加or更新BOM表中系列名称
*/
export const saveBOMSerialName = (data) => request.post('/api-qc/saveBOMSerialName', data);

/**
 * 获得BOM表中系列名称
*/
export const getBOMSerialName = (params) => request.get('/api-qc/getBOMSerialName', { params });

/**
 * 修改物料关联提示
*/
export const materialAssociationPrompt = (params) => request.get('/api-qc/materialAssociationPrompt', { params });

/**
 * 物料编码关联项目BOM
*/
export const getProjectLifeCycleByMaterialModelCodeId = (params) => request.get('/api-qc/getProjectLifeCycleByMaterialModelCodeId', { params });

/**
 * 获取物料编码多版本
*/
export const getListByMaterialCode = (params) => request.get('/api-qc/getListByMaterialCode', { params });

/**
 * 导出物料编码
*/
export const exportMaterialModelCode = (data) => request.post('/api-qc/exportMaterialModelCode', data, {
    responseType: 'blob'
});
